// extracted by mini-css-extract-plugin
export default {"wrapper":"Create_wrapper__kaf7z","footer":"Create_footer__J5ygp","hiddenZone":"Create_hiddenZone__WgtdV","visible":"Create_visible__m+XiY","sensors":"Create_sensors__PVvk4"};